import {authenticate, user, userUpdate} from "../../api";
import {EventBus, isValidJwt, parseJwt} from "../../utils";

export default {
    state: {
        jwt: {},
        user: {},
        userFetched: false
    },

    mutations: {
        setJwtToken(state, payload) {
            console.log('setJwtToken payload = ', payload);
            if (typeof payload.jwt.token !== 'undefined') {
                window.localStorage.setItem('token', payload.jwt.token)
            }
            state.jwt = payload.jwt
        },

        logout(state, payload) {
            console.log('logout payload = ', payload);
            window.localStorage.removeItem('token');
            state.jwt = ''
        },

        setUserData(state, payload) {
            console.log('setUserData payload = ', payload);
            state.user = payload
            state.userFetched = true;
        },
    },

    actions: {
        login(context, userData) {
            return authenticate(userData)
                    .then(response => context.commit('setJwtToken', {jwt: response.data}))
                    .catch(error => {
                        EventBus.$emit('failedAuthentication', error)
                    })
        },

        getUserData(context, token) {
            return user(token.token)
                    .then(response => {
                        context.commit('setUserData', response.data)
                        EventBus.$emit('userFetched', response.data)
                    })
                    .catch((err) => EventBus.$emit('userFetcherFail', err))
        },

        savePin(context, pin) {
            let token = context.getters.getToken;
            pin = pin.join("");
            return userUpdate({token, pin})
                    .then(response => {
                        EventBus.$emit('user.pin_saved', response.data);
                        context.state.user.pin_code = pin
                    })
                    .catch((err) => EventBus.$emit('userFetcherFail', err))
        },
    },

    getters: {
        isAuthenticated(state) {
            return isValidJwt(state.jwt.token)
        },

        getToken(state) {
            return parseJwt(state.jwt.token)
        },

        isUserFetched(state) {
            return state.userFetched;
        }
    }
}